import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import "./homeDropdown.css";

function HomeDropdown({ handleCategoryReset }) {
  return (
    <>
      <Dropdown id="dropdown" as={ButtonGroup}>
        <Dropdown.Toggle className="py-0 ps-0 me-3" id="dropdown-custom-1">
          <i className="fa-solid fa-bars"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="super-colors py-0">
          <Dropdown.Item eventKey="1">
            <Link className="text-decoration-none text-secondary py-1" to="/">
              Home
            </Link>
          </Dropdown.Item>
          <Dropdown.Divider className="my-0" />
          <Dropdown.Item eventKey="2">
            <Link
              className="text-decoration-none text-secondary py-1"
              to="/catalog"
              onClick={(e) => {
                handleCategoryReset(e);
              }}
            >
              All Products
            </Link>
          </Dropdown.Item>
          <Dropdown.Divider className="my-0" />
          <Dropdown.Item eventKey="3">
            <Link
              className="text-decoration-none text-secondary py-1"
              to="/contact"
            >
              Contact Us
            </Link>
          </Dropdown.Item>
          <Dropdown.Divider className="my-0" />
          <Dropdown.Item className="bg-dark my-0" eventKey="4">
            <Link
              id="about-project-item"
              className="text-decoration-none text-white py-1 "
              to="/about-project"
            >
              About Project
            </Link>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>{" "}
    </>
  );
}

export default HomeDropdown;
